import script from "./ListTagTypes.vue?vue&type=script&setup=true&lang=js"
export * from "./ListTagTypes.vue?vue&type=script&setup=true&lang=js"

import "./ListTagTypes.vue?vue&type=style&index=0&id=6339a2a2&scoped=true&lang=postcss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6339a2a2"]])

export default __exports__